import { IconProps } from '../icon';

export function AlignementGaucheIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256.02 208" {...props}>
      <g id="a" />
      <g id="b">
        <g id="c">
          <g>
            <path d="M127.94,15.69c-38.51,0-77.02,0-115.53,0-1.83,0-3.69,.09-5.48-.21C2.61,14.75-.07,12.18,.02,7.68,.11,3.17,2.99,.82,7.26,.14c1.47-.23,2.99-.09,4.49-.09,77.52,0,155.04,0,232.56,0,7.98,0,11.63,2.42,11.7,7.73,.07,5.27-3.75,7.91-11.54,7.91-38.84,0-77.69,0-116.53,0Z" />
            <path d="M127.48,144.05c-38.67,0-77.35,0-116.02,0-1.67,0-3.39,.19-4.99-.14-4.06-.86-6.55-3.44-6.45-7.67,.1-4.17,2.47-6.8,6.71-7.37,1.81-.24,3.66-.19,5.49-.19,77.18,0,154.37,0,231.55,0,1.83,0,3.68-.06,5.49,.19,4.24,.57,6.6,3.21,6.7,7.38,.1,4.23-2.4,6.81-6.46,7.66-1.6,.34-3.32,.14-4.99,.14-39.01,0-78.02,0-117.02,0Z" />
            <path d="M92.5,79.38c-26.83,0-53.67,0-80.5,0-1.83,0-3.68,.05-5.49-.22-4-.59-6.26-3.14-6.49-7.06-.25-4.24,2.18-6.86,6.17-7.93,1.25-.33,2.65-.17,3.98-.17,54.67,0,109.33,0,164,0,1.33,0,2.72-.16,3.98,.16,4.02,1.02,6.4,3.62,6.21,7.88-.18,3.96-2.31,6.54-6.38,7.11-1.8,.25-3.66,.22-5.49,.22-26.67,.01-53.33,0-80,0Z" />
            <path d="M61.46,208c-16.84,0-33.68,.02-50.52-.02-1.81,0-3.7-.04-5.42-.53C1.91,206.42-.07,203.81,0,200.05c.08-3.74,2.1-6.29,5.77-7.19,1.75-.43,3.62-.5,5.44-.5,33.68-.03,67.36-.02,101.03-.02,.67,0,1.33-.01,2,0,5.89,.19,9.68,3.35,9.57,7.96-.11,4.64-3.87,7.66-9.84,7.67-17.51,.04-35.01,.01-52.52,.01Z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AlignementGaucheIcon;
